export const displayAmountWithCurrency = (amount: number, currency: string = 'SEK') => {
  return `${amount.toLocaleString('sv-SE')} ${currency}`
}
